export const messages = {
  title: { id: 'admin/promotions.form.campaign.audience.conditions.title' },
  subtitle: {
    id: 'admin/promotions.form.campaign.audience.conditions.subtitle',
  },
  goToAudiences: {
    id: 'admin/promotions.form.campaign.audience.editor.navigate-button',
  },
}
